import { Routes } from '@angular/router';
import { PlaceholderComponent } from './global-components/placeholder/placeholder.component';
import { SignInComponent } from './features/sign-in/sign-in.component';
import { SignUpComponent } from './features/sign-up/sign-up.component';
import { ObCreateOrgComponent } from './features/onboarding/ob_create_org.component';
import { AuthGuard } from './global-guards/auth.guard';
import { GuestGuard } from './global-guards/guest.guard';
import { FormFillGuard } from './global-guards/form-fill.guard';
import { ConfirmEmailComponent } from './features/onboarding/confirm-email/confirm-email.component';
import { ManageOrgComponent } from './features/manage-organisation/manage-org.component';
import { MeComponent } from './features/me/me.component';
import { AcceptInviteComponent } from './features/accept-invite/accept-invite.component';
import { ManagePatientsComponent } from './features/manage-patients/manage-patients.component';
import { ManageFormsComponent } from './features/manage-forms/manage-forms.component';
import { CrudFormAssignmentComponent } from './features/crud-form-assignment/crud-form-assignment.component';
import { GlobalFormFillErrorComponent } from './global-components/global-form-fill-error';
import { FormFillComponent } from './features/form-fill/form-fill.component';
import { PatientDashboardComponent } from './features/patient-dashboard/patient-dashboard.component';
import { OrgFormAssignmentsComponent } from './features/org-form-assignments/org-form-assignments.component';
import { FormSubmissionSuccessComponent } from './global-components/form-submission-success/form-submission-success.component';
import { CrudVisitComponent } from './features/crud-visit/crud-visit.component';
import { CalculatePremoComponent } from './features/calculate-premo/calculate-premo.component';

export const routes: Routes = [
  {
    path: 'me',
    component: MeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'sign-up/confirm-email',
    component: ConfirmEmailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'sign-up/ob-create-org',
    component: ObCreateOrgComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'sign-up',
    component: SignUpComponent,
    canActivate: [GuestGuard],
    data: { guestOnly: true },
  },
  {
    path: 'sign-in',
    component: SignInComponent,
    canActivate: [GuestGuard],
    data: { guestOnly: true },
  },
  {
    path: 'admin/dashboard',
    component: PlaceholderComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/orgs',
    component: PlaceholderComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'home',
    component: PlaceholderComponent,
    canActivate: [AuthGuard],
  },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'orgs/:orgId/manage',
    component: ManageOrgComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'orgs/:orgId/patients/manage',
    component: ManagePatientsComponent,
    canActivate: [AuthGuard],
  },

  {
    path: "orgs/:orgId/patients/:patientId/manage",
    component: PatientDashboardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'orgs/:orgId/forms/manage',
    component: ManageFormsComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'orgs/:orgId/form-assignments',
    component: OrgFormAssignmentsComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'orgs/:orgId/patients/:patientId/form-assignments/create',
    component: CrudFormAssignmentComponent,
    canActivate: [AuthGuard],
    data: { crudMode: 'CREATE' },
  },
  {
    path: 'orgs/:orgId/patients/:patientId/form-assignments/:assignmentId/view',
    component: CrudFormAssignmentComponent,
    canActivate: [AuthGuard],
    data: { crudMode: 'READ' },
  }, {
    path: 'orgs/:orgId/patients/:patientId/form-assignments/:assignmentId/edit',
    component: CrudFormAssignmentComponent,
    canActivate: [AuthGuard],
    data: { crudMode: 'UPDATE' },
  },
  {
    path: 'orgs/:orgId/patients/:patientId/visit/create',
    component: CrudVisitComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'orgs/:orgId/patients/:patientId/visit/:visitId/update',
    component: CrudVisitComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'orgs/:orgId/patients/:patientId/calculate-premo',
    component: CalculatePremoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'form-fill/:assignmentId',
    component: FormFillComponent,
    canActivate: [FormFillGuard],
  },

  {
    path: 'form-fill-error/:errorType',
    component: GlobalFormFillErrorComponent,
  },

  {
    path: 'accept-invite/:token',
    component: AcceptInviteComponent,
  },
  {
    path: "form-submission-success",
    component: FormSubmissionSuccessComponent,
  }
];
